<template>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-card>
          <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
          <ul class="m-list-wrapper">
            <li>
              <a-input-search v-model="search" placeholder="Quick Search" />
            </li>
            <li>
              <a-collapse :activeKey="getScreen ? 0 : 1">
                <a-collapse-panel key="1">
                  <span slot="header">Search More...</span>
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Transaction Date</label>
                    <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="searchDate"
                      :format="getDefaultDateFormat" allowClear />
                  </div>
                  <div class="m-form-item-wrapper">
                    <label for="kategori">Category</label>
                    <a-select placeholder="Ex: Project ... " v-model="kategori" class="width-full" allowClear>
                      <a-select-option v-for="item in getKategori" :key="item.id" :value="item.value">{{ item.label
                      }}</a-select-option>
                    </a-select>
                  </div>
                  <div class="m-form-item-wrapper">
                    <label>Status</label>
                    <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                      allowClear>
                      <a-select-option v-for="item in getStatusKlaimPD" :key="item.id" :value="item.value">{{ item.label
                      }}</a-select-option>
                    </a-select>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </li>
          </ul>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <DataList :loading="loading" title="Credit Card PP Claims List" :manifestLink="getManifestLink" :dataList="searching"
          :price="true" :disabledCreateEditLink="true" :isMonitoring="true" />
      </a-col>
    </a-row>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import axios from "axios";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import _ from "lodash";
  
  export default {
    name: "ListKlaimPp",
    props: ["prnMenu"],
    mixins: [CurrencyFormat],
    data() {
      return {
        loading: true,
        dataList: [],
        kategori: undefined,
        searchDate: [],
        search: "",
        status: undefined,
      };
    },
    mounted() {
      this.fetchData();
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getStatusKlaimPD",
        "getKategori",
        "getDefaultDateFormat",
        "getStandartFormatDate",
      ]),
      searching() {
        var self = this;
        let outputData = this.dataList;
  
        if (this.search) {
          outputData = _.filter(
            outputData,
            (obj) =>
              (obj.searchQ !== undefined ? obj.searchQ : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0
          );
        }
  
        if (this.searchDate && this.searchDate.length > 0) {
          let startDt = moment(this.searchDate[0]).format(this.getDefaultDateFormat);
          let endDt = moment(this.searchDate[1]).format(this.getDefaultDateFormat);
  
          outputData = outputData.filter(
            (obj) =>
              obj.tgl_buat &&
              moment(obj.tgl_buat).format(this.getDefaultDateFormat) >= startDt &&
              moment(obj.tgl_buat).format(this.getDefaultDateFormat) <= endDt
          );
        }
  
        if (this.kategori) {
          outputData = _.filter(outputData, { peruntukan: self.kategori });
        }
  
        if (this.status) {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
          );
        }
  
        return outputData;
      },
      getManifestLink() {
        if (localStorage.getItem("nvpn") === "/keuangan") {
          return "SpclKlaimCCPPManifestKeu";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          return "SpclKlaimPPManifestPimpro";
        } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
          return "SpclKlaimPPManifestAL";
        } else if (localStorage.getItem("nvpn") === "/direktur") {
          return "SpclKlaimPPManifestDir";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          return "SpclKlaimCCPPManifestACC";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          return "SpclMenuMonKlaimCCPPManifestVP";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          return "SpclKlaimPPManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          return "SpclKlaimCCPPManifestFin";
        } else {
          return "SpclKlaimPPManifest_";
        }
      },
    },
    methods: {
      moment,
      fetchData() {
        axios({
          method: "get",
          url: this.$serviceUrl + "monitoring/klaim_cc_pp",
          params: {
            tlc: this.getAuth.username,
            id: localStorage.getItem("nvky"),
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            if (response !== undefined) {
              _.forEach(response.data.data, (data) => {
                this.dataList.push({
                  searchQ:
                    data.no_klaim_cc_pppd +
                    " " +
                    data.total_pemakaian +
                    " " +
                    data.currency +
                    " " +
                    data.tlc_pembuat,
                  tgl_buat: data.tgl_buat,
                  peruntukan: data.peruntukan,
                  title: data.no_klaim_cc_pppd,
                  timeline: JSON.parse(data.status_app),
                  unread: data.unread == "1" ? true : false,
                  subdesc: [
                    [
                      {
                        label: moment(data.tgl_buat).format(
                          this.getDefaultDateFormat
                        ),
                        value: "",
                      },
                    ],
                    [
                      {
                        label: this.formatCurrency(
                          data.currency,
                          data.total_pemakaian
                        ),
                        value: "",
                      },
                    ],
                  ],
                  status: data.status,
                  id: data.id_manifest,
                  price: data.grand_total,
                });
              });
            } else {
              this.dataList = [];
            }
  
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
    },
  };
  </script>
  
  <style></style>
  